import { environment } from "./environments/environment";
import { GRPC_CUSTOMER_ASSETS_ENDPOINT_CLIENT_SETTINGS, GRPC_IDENTITY_ENDPOINT_CLIENT_SETTINGS, GRPC_LOGGER_ENDPOINT_CLIENT_SETTINGS } from "./protos/generated/admin.pbconf";

export function createGrpcSettings() {
    return {
        host: environment.grpcHost,
    };
}

export const GRPC_PROVIDERS = [
    {
        provide: GRPC_LOGGER_ENDPOINT_CLIENT_SETTINGS,
        useFactory: createGrpcSettings
    },
    {
        provide: GRPC_CUSTOMER_ASSETS_ENDPOINT_CLIENT_SETTINGS,
        useFactory: createGrpcSettings
    },
    {
        provide: GRPC_IDENTITY_ENDPOINT_CLIENT_SETTINGS,
        useFactory: createGrpcSettings
    }
];